import { ACTIVE_LUMINANCE, HOVER_LUMINANCE } from "../constants";
import { changeRgbLuminance } from "./changeRgbLuminance";
const getStateColor = (hex, state) => {
  if (state === 'normal') {
    return changeRgbLuminance(hex, 0);
  } else if (state === 'hover') {
    return changeRgbLuminance(hex, HOVER_LUMINANCE);
  } else if (state === 'pressed' || state === 'focused') {
    return changeRgbLuminance(hex, ACTIVE_LUMINANCE);
  }
};
export { getStateColor };